import FullBleedQuestionnaire from './FullBleedQuestionnaire';

export default FullBleedQuestionnaire;
